import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerPhoneEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.businessPhones?.[0] && !currentTicket?.customerInfo.customerPhone) {
      dispatch(updateTicketCustomerInfo({ customerPhone: graphData.businessPhones[0] }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerPhone]);

  return (
    <TextField
      label="Customer Phone"
      size="small"
      fullWidth
      value={currentTicket?.customerInfo.customerPhone || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerPhoneEdit;
